import { OperationalParametric } from "../../cliente/operationalParametric.model";

export class AprobacionDocumento {

  id: number;
  path: string;
  tipoDocumentacion: OperationalParametric;
  estadoDocumentacion: OperationalParametric;
  motivoRechazo: OperationalParametric;
}


// WEBPACK FOOTER //
// ./src/app/shared-components/validar-documentacion/aprobacionDocumento.model.ts